
import React from "react";

import { SectionHeader } from "@/components/ui/section-header";
import { Helmet } from "react-helmet";

export default function CookiesPage() {
  return (
    <>
      <Helmet>
        <title>Cookie Policy | Grandpal</title>
      </Helmet>
      
      <div className="container max-w-4xl py-16">
        <SectionHeader 
          title="Cookie Policy"
          subtitle="Last updated: April 20, 2025"
          centered
        />
        
        <div className="prose prose-lg max-w-none">
          <h3>What Are Cookies</h3>
          <p>
            Cookies are small text files that are placed on your computer or mobile device when you visit our website. They help us provide you with a better experience and understand how you interact with our services.
          </p>
          
          <h3>How We Use Cookies</h3>
          <p>
            We use cookies to:
          </p>
          <ul>
            <li>Remember your preferences and settings</li>
            <li>Understand how you use our website</li>
            <li>Improve our services</li>
            <li>Keep you signed in to your account</li>
          </ul>
          
          <h3>Managing Cookies</h3>
          <p>
            You can control and manage cookies in your browser settings. Please note that removing or blocking cookies may impact your user experience on our website.
          </p>
        </div>
      </div>
    </>
  );
}
